module.exports = __webpack_public_path__ + "img/H3.99d8075d.png";